<template>
    <v-row
        align="center"
        class="switch-input"
    >
        <v-switch
            hide-details
            inset
            v-model="model"
            :color="color"
        >
        </v-switch>
        <span 
            class="pt-4"
            :class="{
                'enable-switch' : value,
                'desabled-switch' : !value,
            }"
        >{{ label }}</span>
    </v-row>
</template>

<script type="text/javascript">
  export default {
    props: {
        color: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        value: {
            type: Boolean,
            default: false,
        },
    },
    data() {
      return {
      }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)

            },
        },
    },
  }
</script>


<style  lang="scss">
    .switch-input {
        .enable-switch {
            color: $black-switch-enable;
        }
        .desabled-switch {
            color: $grey-switch-desabled;
        }
    }
</style>